// Subdomain → portal (kullanıcı tipi) eşlemesi. Aynı build hem stage hem prod'da
// birden çok alt domaine deploy edilir; hangi domainde çalıştığımıza göre giriş/kayıt
// davranışı değişir (API ortamı — stage/prod — ise build'e gömülü API_URL ile belirlenir).
//
//   my.troydepo.com       / stage-my.troydepo.com       → customer (Müşteri girişleri)
//   partner.troydepo.com  / stage-partner.troydepo.com  → merchant (Merchant girişleri)
//   panel.troydepo.com    / stage-panel.troydepo.com    → admin    (Admin girişleri)
//   panel-troydepo.com    / stage-panel-troydepo.com    → admin    (eski tireli admin domaini)
//
// localhost / IP → null (kısıt yok). Geliştirmede YALNIZ URL'de ?portal=customer|merchant|admin
// varken taklit edilir (kalıcı DEĞİL — aksi halde bir kez verilince localhost'ta kısıt takılı kalır).

const PORTAL_BY_LABEL = {
  my: "customer",
  partner: "merchant",
  panel: "admin",
  "panel-troydepo": "admin",
};

const VALID_PORTALS = ["customer", "merchant", "admin"];

export function getPortal() {
  try {
    const host = String(window.location.hostname || "").toLowerCase();

    // Geliştirme (localhost / IP): domain yok → YALNIZ URL'deki ?portal ile taklit (kalıcı değil).
    if (host === "localhost" || host === "127.0.0.1" || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) {
      try {
        const q = new URLSearchParams(window.location.search).get("portal");
        return VALID_PORTALS.includes(q) ? q : null;
      } catch (e) {
        return null;
      }
    }

    // İlk etiketten stage- önekini at → "my" | "partner" | "panel" | "panel-troydepo"
    const label = host.split(".")[0].replace(/^stage-/, "");
    return PORTAL_BY_LABEL[label] || null;
  } catch (e) {
    return null;
  }
}

// Giriş isteğine giden portal adı (user-login "portal" alanı; güvenlik manifesti FE-P2-4).
// Kullanıcı tipinden farkı: merchant portalı BE'ye "partner" olarak bildirilir. Portal yoksa (localhost) "".
const LOGIN_PORTAL = { customer: "customer", admin: "admin", merchant: "partner" };
export function getLoginPortal() {
  return LOGIN_PORTAL[getPortal()] || "";
}

// Portalın kayıt ETTİĞİ kullanıcı tipi (admin portalında self-kayıt yok → merchant başvurusu
// gibi davranır, çünkü admin için değişiklik istenmedi).
export function getRegisterType() {
  return getPortal() === "customer" ? "customer" : "merchant";
}

export const PORTAL_TYPE_LABELS = {
  customer: "Müşteri",
  merchant: "Partner",
  admin: "Yönetici",
};

// MÜŞTERİ portalının kökü (ör. oda yetkilisi daveti onaylanınca "Panele giriş yap" bağlantısı).
// Davet linki BE'den ADMIN alan adına (stage-panel / panel) gelir; ama davetli kişi MÜŞTERİ hesabıdır
// ve admin portalında müşteri girişi engellidir → aynı ortamın "my" alt alan adına çevrilir.
// localhost / IP'de (geliştirme) müşteri portalı ?portal=customer ile taklit edilir; tanınmayan alan adında
// olduğu yerin kökü döner.
export function getCustomerPortalUrl(locationLike) {
  try {
    const loc = locationLike || window.location;
    const host = String(loc.hostname || "").toLowerCase();
    const origin = `${loc.protocol}//${loc.host}`;
    const parts = host.split(".");
    const first = parts[0] || "";
    const isStage = first.startsWith("stage-");
    const label = first.replace(/^stage-/, "");
    if (host === "localhost" || host === "127.0.0.1" || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) {
      return `${origin}/?portal=customer`;
    }
    if (!PORTAL_BY_LABEL[label] || parts.length < 2) return origin;
    // Eski tireli admin alanı (panel-troydepo.com): kök alan adı "troydepo.com".
    const rest = label === "panel-troydepo" ? ["troydepo", ...parts.slice(1)] : parts.slice(1);
    return `${loc.protocol}//${isStage ? "stage-my" : "my"}.${rest.join(".")}`;
  } catch (e) {
    return "/";
  }
}

// FE-76 (21.10.2026): verilen kullanıcı tipinin portal kök adresi (aynı ortam: stage-* korunur).
// Yanlış portaldan giriş denendiğinde doğru adresi göstermek için. Tanınmayan alan adında/localhost'ta
// ?portal=… ile aynı köken döner.
const LABEL_BY_PORTAL = { customer: "my", merchant: "partner", admin: "panel" };
export function getPortalUrl(type, locationLike) {
  try {
    const loc = locationLike || window.location;
    const host = String(loc.hostname || "").toLowerCase();
    const origin = `${loc.protocol}//${loc.host}`;
    const hedef = LABEL_BY_PORTAL[type];
    if (!hedef) return origin;
    if (host === "localhost" || host === "127.0.0.1" || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) {
      return `${origin}/?portal=${type}`;
    }
    const parts = host.split(".");
    const first = parts[0] || "";
    const isStage = first.startsWith("stage-");
    const label = first.replace(/^stage-/, "");
    if (!PORTAL_BY_LABEL[label] || parts.length < 2) return origin;
    const rest = label === "panel-troydepo" ? ["troydepo", ...parts.slice(1)] : parts.slice(1);
    return `${loc.protocol}//${isStage ? "stage-" : ""}${hedef}.${rest.join(".")}`;
  } catch (e) {
    return "/";
  }
}
